// Public episode waveform: the whole set drawn out — tap anywhere to hear it from there.
import { useEffect, useState } from "react";
import axios from "axios";
import { API } from "../../App";
import { useRadio, fmtTime } from "../../radio/RadioContext";
import { Waveform } from "./Waveform";

const FLAT = Array(240).fill(0.12);

export const EpisodeWave = ({ ep, slug }) => {
  const r = useRadio();
  const [peaks, setPeaks] = useState(ep.waveform_peaks || null);
  const [dur, setDur] = useState(ep.duration_sec || 0);
  useEffect(() => {
    if (ep.waveform_peaks?.length) return undefined;
    let n = 0, stop = false, t;
    const poll = () => axios.get(`${API}/radio/episodes/${slug}/peaks`).then(({ data }) => {
      if (stop) return;
      if (data.peaks) { setPeaks(data.peaks.length ? data.peaks : FLAT); if (data.duration_sec) setDur(data.duration_sec); }
      else if (data.pending && n++ < 20) t = setTimeout(poll, 3000);
      else setPeaks(FLAT);
    }).catch(() => setPeaks(FLAT));
    poll();
    return () => { stop = true; clearTimeout(t); };
  }, [slug, ep.waveform_peaks]);
  const isCur = r.episode?.episode_id === ep.episode_id;
  const d = dur || (isCur ? r.duration : 0);
  const seek = (s) => { if (isCur) { r.seek(s); if (!r.playing) r.toggle(); } else r.load(ep, s); };
  return (
    <div className="mt-8 rounded-3xl bg-[#120A24] ring-1 ring-[#54E3FF]/30 p-5 sm:p-6" data-testid="episode-wave">
      <div className="flex items-center justify-between gap-3 mb-3">
        <p className="m-0 text-[11px] font-black tracking-[0.2em] text-white/50">TAP ANYWHERE ON THE WAVE TO HEAR IT FROM THERE</p>
        <p className="m-0 text-xs font-bold tabular-nums text-white/75" data-testid="episode-wave-time">{fmtTime(isCur ? r.time : 0)} / {fmtTime(d)}</p>
      </div>
      <Waveform peaks={peaks} duration={d} time={isCur ? r.time : 0} onSeek={seek} markers={ep.chapters || []} height={96} accent="#54E3FF" testid="episode-waveform" />
    </div>
  );
};
